import { z } from 'zod';
const uuid = z.uuid();
export const institutionFilingSchema = z
    .object({ programmeId: uuid, enabled: z.boolean(), validUntil: z.iso.datetime({ offset: true }) })
    .strict()
    .refine((v) => Date.parse(v.validUntil) > Date.now() &&
    Date.parse(v.validUntil) <= Date.now() + 90 * 86400000, { message: 'Filing needs a future expiry within ninety days.' });
export const institutionDocumentCheckSchema = z
    .object({ packageId: uuid, destination: z.url().refine((v) => v.startsWith('https://')) })
    .strict();
export const institutionDraftReconcileSchema = z
    .object({
    interactionId: uuid,
    sentMessageId: z
        .string()
        .regex(/^[a-fA-F0-9]{1,100}$/)
        .optional(),
})
    .strict();
export function driveFileId(url) {
    try {
        const u = new URL(url);
        if (u.protocol !== 'https:' ||
            !['drive.google.com', 'docs.google.com'].includes(u.hostname) ||
            u.username ||
            u.password)
            return null;
        const id = u.pathname.match(/\/d\/([A-Za-z0-9_-]+)/)?.[1] ??
            (u.pathname === '/open' ? u.searchParams.get('id') : null);
        return id && /^[A-Za-z0-9_-]{10,200}$/.test(id) ? id : null;
    }
    catch {
        return null;
    }
}
//# sourceMappingURL=institution-operations.js.map